import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { Lead, CloseLeadDto } from '@/types/lead';

export function useCloseLead() {
  const queryClient = useQueryClient();

  return useApiMutation<Lead, { leadId: string } & CloseLeadDto>({
    mutationFn: ({ leadId, ...dto }) =>
      apiPost<Lead, CloseLeadDto>(operationsClient, leadEndpoints.close(leadId), dto),
    onSuccess: (data, { leadId }) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(leadId) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead closed');
    },
  });
}
